import React from 'react';
import AppRouter from './routes/AppRouter';
import { ConfigProvider } from 'antd';
// import './App.css';
import 'antd/dist/reset.css';

export default function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#f5721d',
        },
      }}
    >
      <AppRouter />
    </ConfigProvider>
  );
}
